import { SlotGameType1_2 } from "../SlotGameType1_2";
import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";

// import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
// import { SetStyles } from "../.././MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import { FontResource } from "../../ResourceManager/FontResource";
import { SlideFactory } from "../Slider/SecondScreenHelp"
import { SetStyles } from "../.././MyHelpers";
// namespace SlotGames2
// {
	export class SecretsOfAnubis2 extends SlotGameType1_2
	{
		protected override seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide();

		// public override TitleLoaded(resourceManager: IReadOnlyResourceManager)
		// {
		// 	super.TitleLoaded(resourceManager);
		// 	SetStyles(this.view.querySelector(".title"),
		// 	{
		// 		display:"flex",
		// 		justifyContent:"center",
		// 		margin:"26px"
		// 	});
		// }

		// public PrepareFont(resourceManager: ResourceManager)
		// {
		//  resourceManager.Add(new FontResource(this.basepath + "resources/TrajanPro-Bold.ttf",this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }
	}
// }